module.exports = __webpack_public_path__ + "static/img/zxxd.9838ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linshi/zxxd.png
// module id = rk0c
// module chunks = 44